import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss']
})
export class MembersComponent implements OnInit {
  /**
   * The ID of Current Company
   */
  id;
  /**
   * The Columns to be shown
   */
  displayedColumns: string[] = ['number', 'ID', 'name', 'email', 'mobile', 'role', 'state', 'partnerMailRecipient', 'menu'];
  /**
   * The Data to be shown
   */
  dataSource;
  /**
   * The Current Company
   */
  currentbusinessEntity: BusinessEntityResource;
  /**
   * The State of the Memerbers
   */
  public sortOptionsState: SortOption[] = [
    { value: "NEW", viewValue: "NEW" },
    { value: "PENDING", viewValue: "PENDING" },
    { value: "REJECTED", viewValue: "REJECTED" },
    { value: "ACTIVE", viewValue: "ACTIVE" },
    { value: "DISABLE_REQUEST", viewValue: "DISABLE_REQUEST" },
    { value: "DISABLED", viewValue: "DISABLED" },
    { value: "DELETED", viewValue: "DELETED" }
  ];
  /**
   * constructor
   * @param route 
   * @param businessEntityService 
   * @param businessuserService 
   * @param overlayService 
   */
  constructor(
    private route: ActivatedRoute,
    private businessEntityService: BusinessEntityService,
    private businessuserService: BusinessuserService,
    private overlayService: OverlayService
  ) { }
    /**
     * ngOnInit
     */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      return combineLatest([
        this.businessEntityService.getBusinessEntityService(params['id']),
        this.businessEntityService.getMembersToBusinessEntity(params['id'])
      ]).pipe(
        map(([businessEntity, members]: any) => {
          this.currentbusinessEntity = businessEntity;
          console.log(members)
          this.dataSource = new MatTableDataSource(members);
        })).subscribe()
    })
  }
  /**
   * change the State of the Member
   * @param e 
   */
  changeState(e: BusinessUserResource) {
    this.overlayService.openBottomSheetBusinessUserResourceState(e).subscribe(value => {
      this.ngOnInit();
    });
  }
  /**
   *  change the Role of the Member
   * @param e 
   */
  changeRole(e: BusinessUserResource) {
    this.overlayService.openBottomSheetBusinessUserResourceRole(e).subscribe(value => {
      this.ngOnInit();
    });
  }
  /**
   * activate the Mail of the Member
   * @param user 
   * @param val 
   */
  activateMail(user: BusinessUserResource, val) {
    this.businessuserService.activateMail(user['businessContractPublicId'], val).subscribe(val => {
      this.ngOnInit();
    })
  }
  /**
   * Open the Dialog to reset the PW of the Member
   * @param user 
   */
  openResetPassword(user: BusinessUserResource) {
    this.overlayService.openResetPWUserDialog("Passwort zurücksetzen", "", "Passwort setzen", user)
  }

  deleteMember(user: BusinessUserResource){
    this.businessuserService.changeState(user, "DELETED").subscribe((value: BusinessUserResource) => {
      if (value.publicId != null) {
        this.overlayService.openSnackBar('Status erfolgreich geändert!');
      }
    })
  }
}
